export default __webpack_public_path__ + "static/banner-84ef18e01729a6202c2c9b3c8ef46a38.svg";